<template>
  <a-form-model :model="form" :rules="rules" ref="smsCodeForm">
    <div class="sms-code-tip">
      为保障帐号安全，登录验证码将发送到<em>{{ userInfo.mobile }}</em
    >手机<br/>
      如该手机号码有误或不可用，请联系您的省级管理用户进行修改。
    </div>
    <a-row>
      <a-col :span="16">
        <a-form-model-item
          label="验证码"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="code"
        >
          <a-input v-model="form.code" placeholder="请输入六位数验证码"/>
        </a-form-model-item>
      </a-col>
      <a-col :span="8">
        <a-button
          :disabled="disabled"
          type="primary"
          ghost
          class="set-code-btn"
          @click="setCode"
        >
          {{ text }}
        </a-button>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>

// 验证码校验
const validateCode = (rule, value, callback) => {
  if (!/^[0-9]{6}$/.test(value)) {
    callback(new Error("请输入六位数验证码"));
  } else {
    callback();
  }
};

export default {
  name: "SmsCode",
  data() {
    return {
      disabled: false,
      text: "获取验证码",
      times: 60,
      rules: {
        code: [
          {required: true, message: "验证码不能为空", trigger: "blur"},
          {validator: validateCode, trigger: ["blur"]}
        ]
      },
      form: {
        hash: this.userInfo.hash,
        code: ""
      }
    }
  },

  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },

  methods: {
    setCode() {
      this.disabled = true;
      this.countDown(60);

      const params = {
        token: this.$props.userInfo.smsToken,
      };

      this.$json("sendLoginSms", params).then(res => {
        if (res.code) {
          this.$message.error(res.message);
        } else {
          this.$message.success("验证码已发送，请注意查收");
        }
      });

      // const params = {hash: this.userInfo.hash};
      /*request("sendSms", params).then(res => {

        const {code, message} = res.data;
        if (code) {
          this.$message.error(message);
        } else {
          this.$message.success("验证码已发送，请注意查收");
        }
      });*/
    },
    countDown(times) {
      this.times = times;
      const timer = setInterval(() => {
        this.times--;
        this.text = `重新发送(${this.times})`;
        if (this.times === 0) {
          this.disabled = false;
          this.text = "重新发送";
          clearInterval(timer);
        }
      }, 1000);
    }
  },
}
</script>

<style lang="less" scoped>
.sms-code-tip {
  padding-bottom: 10px;

  em {
    font-style: normal;
    font-weight: bold;
  }
}

.set-code-btn {
  float: right;
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/SmsCode.vue